<template>
  <v-navigation-drawer
    v-model="drawer"
    :width="275"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    temporary
  >
    <v-card flat>
      <v-row align="end" class="pa-2 fill-height">
        <v-col>
          <a href="/" :alt="$t('nav.returnToHome')"
            ><v-img class="mr-12"
              src="https://klosterwelt-pommern.de/wp-content/uploads/2022/07/klosterwelt-pommern_brand_4.svg"
            />
          </a>
        </v-col>
      </v-row>
    </v-card>
    <v-list dense shaped subheader>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        :to="'/' + config()['slug'] + item.link"
        link
        exact
        color="primary"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <v-list dense shaped>
        <v-list-item
          v-if="
            config()['allowUserLogin'] ||
            config()['allowUserRegistration'] ||
            config()['allowPasswordReset']
          "
          @click="!getUser ? login() : logout()"
          link
          exact
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{
              !getUser ? $t("login.login") : $t("login.logout")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item href="/" link>
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t("nav.returnToHome") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { eventBus } from "../../main.js";
export default {
  computed: {
    drawer: {
      get() {
        return this.$store.state.nav;
      },
      set(val) {
        this.$store.commit("nav", val);
      },
    },
    getUser: {
      get() {
        return this.$store.state.user;
      },
    },
  },
  data: function () {
    return {
      items: [{ title: this.$i18n.t("nav.map"), icon: "mdi-map", link: "/" }],
    };
  },
  methods: {
    config() {
      return this.$mmconfig;
    },
    login() {
      this.drawer = false;
      eventBus.$emit("login");
    },
    logout() {
      this.drawer = false;
      eventBus.$emit("logout");
    },
  },
};
</script>